// JsFromRoutes CacheKey cc8fbd7d7b3c1d34118fa3da104b70c0
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/:account_id/settings/products'),
  update: /* #__PURE__ */ definePathHelper('patch', '/:account_id/settings/products/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/:account_id/settings/products/:id'),
}
